export default __webpack_public_path__ + "assets/images/poop-0540067389e90e4cd6517901885e82e4.png";